// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  width: 75%;
  margin-left: 10%;
  margin-bottom: 10px;
  margin-top: 10px;
}
.card .profile-icon {
  margin-right: 10px;
  background-color: #d6d6d6;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-size: cover;
}

#company-card {
  width: calc(37.5% - 21px);
  margin-left: 10%;
  margin-bottom: 10px;
  float: left;
}

#activity-card {
  width: calc(37.5% - 21px);
  margin-left: 10px;
  margin-bottom: 10px;
  float: left;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/component/pages/profile/profile.component.sass"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AACJ;AACI;EACI,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AACR;;AACA;EACI,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AAEJ;;AAAA;EACI,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;AAGJ","sourcesContent":[".card\n    width: 75%\n    margin-left: 10%\n    margin-bottom: 10px\n    margin-top: 10px\n\n    .profile-icon\n        margin-right: 10px\n        background-color: #d6d6d6\n        width: 50px\n        height: 50px\n        border-radius: 50%\n        background-size: cover\n\n#company-card\n    width: calc(37.5% - 21px)\n    margin-left: 10%\n    margin-bottom: 10px\n    float: left\n\n#activity-card\n    width: calc(37.5% - 21px)\n    margin-left: 10px\n    margin-bottom: 10px\n    float: left"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
